import PanelProfessionalComponent from '../components/PanelProfessional/PanelProfessional'

export default function PanelProfessional() {
    return (
        <div>
            <PanelProfessionalComponent/>
        </div>
    )
}